/**
 * @generated SignedSource<<c0bf79a59aa44b75d7652c004e290a4d>>
 * @relayHash 826aae7140f064570d69504cbde13f64
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 826aae7140f064570d69504cbde13f64

import { ConcreteRequest } from 'relay-runtime';
export type citySelectorGetCitiesQuery$variables = {
  countryIsoCode: string;
  keyword?: string | null;
};
export type citySelectorGetCitiesQuery$data = {
  readonly displayableCities: ReadonlyArray<{
    readonly label: string;
    readonly postalCode: string;
    readonly value: string;
  }>;
};
export type citySelectorGetCitiesQuery = {
  response: citySelectorGetCitiesQuery$data;
  variables: citySelectorGetCitiesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "countryIsoCode"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "keyword"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "countryIsoCode",
        "variableName": "countryIsoCode"
      },
      {
        "kind": "Variable",
        "name": "keyword",
        "variableName": "keyword"
      }
    ],
    "concreteType": "DisplayableCity",
    "kind": "LinkedField",
    "name": "displayableCities",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "label",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "postalCode",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "citySelectorGetCitiesQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "citySelectorGetCitiesQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "826aae7140f064570d69504cbde13f64",
    "metadata": {},
    "name": "citySelectorGetCitiesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2301ddb3e67e9fc1d4117161420a268b";

export default node;
